import { HeadingText, Paragraph } from "./AboutUsComponent";
import FeatureList from "./AboutUsFeatureList";
import { hospitalFeatureList, patientsFeatureList, specialistsFeatureList } from "../../PageComponentData/Profile/Aboutusdata";

export default function AboutUsSection({}){
    return(
        <section className="pt-[12%] lg:pt-[0%] md:pt-[5%] custom_pt_md">
        <HeadingText text={"MODO: Medical On Demand Opinions"} />
        <Paragraph
          text={`MODO is a specialized platform designed to streamline the unorganized
          specialist healthcare system in India, thereby revolutionizing
          specialist access in healthcare. By connecting hospitals with
          certified, verified specialists on an as-needed basis, MODO ensures
          seamless access to expert opinions.`}
        />
        <HeadingText text={"Key benefits of MODO:"} />
        <Paragraph
          text={`All specialists onboard MODO are vetted and their qualifications are
          verified.`}
        />
        <HeadingText text={"For Hospitals:"} />
        <FeatureList features={hospitalFeatureList} />
        <HeadingText text={"For Specialists:"} />
        <FeatureList features={specialistsFeatureList} />
        <HeadingText text={"For Patients:"} />
        <FeatureList features={patientsFeatureList} />
        <div className="mt-4 pb-10 lg:pb-0">
          <Paragraph
            text={`MODO is committed to delivering reliable, efficient, and user-friendly
            healthcare solutions for both hospitals and specialists improving
            patient care and satisfaction`}
          />
        </div>
      </section>
    )
}